// extracted by mini-css-extract-plugin
export default {"rating":"bB-z","numberOfStars":"cB-z","count":"dB-z","barGraphSpacing":"eB-z","barGraph":"fB-z"};